import { render, staticRenderFns } from "./last-approval-person.vue?vue&type=template&id=163fb550&scoped=true&"
import script from "./last-approval-person.vue?vue&type=script&lang=js&"
export * from "./last-approval-person.vue?vue&type=script&lang=js&"
import style0 from "./last-approval-person.vue?vue&type=style&index=0&id=163fb550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fb550",
  null
  
)

export default component.exports